const CbtExecutionStatus = {
  NOT_STARTED: 1,  // 未実施
  IN_PROGRESS: 2,  // 進行中
  FINISHED_NOT_RETURNED: 3,  // 終了 未返却
  FINISHED_RETURNED: 4,  // 終了 返却済
} as const;

const CbtSubmissionStatus = {
  UNANSWERED: 1,  // 未解答
  UNSUBMITTED: 2,  // 未提出
  SUBMITTED: 3,    // 提出済
} as const;

const CbtPollingInterval = {
  DEFAULT: 60000,   // 通常時: 60秒
  ON_ERROR: 120000, // API失敗時: 120秒
} as const;

// 離脱検知の閾値
const DEPARTURE_THRESHOLD_SECONDS = 3;

// NFR-7362: CBT解答欄の観点（バックエンド cbt_work.consts.CbtCriterion と対応）
const CbtCriterion = {
  CHIGI: 1,       // 知識・技能
  SHIHANHYOU: 2,  // 思考・判断・表現（思判表）
} as const;

// NFR-7516: 観点バッジの表示ラベルとCSSクラス。
// クラス名は共通CSSの .c-criterion-tag 配下の修飾子（_test.scss / _preview.scss に定義）と対応する。
// 未定義の観点値（将来の「99: 観点なし」等）は criterionTag() 側で null にフォールバックしバッジを表示しない。
const CbtCriterionTag: Record<number, { label: string; cls: string }> = {
  [CbtCriterion.CHIGI]: { label: "知・技", cls: "-CHIGI" },
  [CbtCriterion.SHIHANHYOU]: { label: "思・判・表", cls: "-SHIHANHYOU" },
};

export {
  CbtExecutionStatus,
  CbtSubmissionStatus,
  CbtPollingInterval,
  DEPARTURE_THRESHOLD_SECONDS,
  CbtCriterion,
  CbtCriterionTag,
};
